/*
  ms-arma-paquete.js — constructor de /pages/arma-tu-paquete.

  Estado: el modo ('sub' | 'once'), la lista de frascos elegidos EN ORDEN
  (cada uno es el id de su tarjeta) y los frascos extra al 50% (lista de ids).

  Del orden sale qué frasco va gratis en el 3x2: el 3º y el 6º. Todos los
  frascos valen lo mismo, así que da igual cuál; se escoge el último de cada
  tercia para que la casilla «Gratis» sea la que el cliente acaba de llenar.

  El carrito se arma con las mismas piezas que ya valida ms-cart-guard.js:
    3x2  -> aniversario-* «1 frasco» (pagados) + regalo-* $0 (gratis)
    2x1  -> aniversario-* «2x1» con plan de 60 días
    +50% -> complemento-* «50», compra única, con `_complemento`
*/
(function () {
  'use strict';

  /* El 3x2 son 3 casillas. Lo que se agregue después va como frasco extra
     al 50%, no como otro 3x2 (decisión de Carlos, 2026-09-18). */
  var MAX_ONCE = 3;
  var MIN_ONCE = 3;
  var SUB_FRASCOS = 2;
  /* En suscripción caben 2 pares de 2x1 (decisión de Carlos, 2026-09-21): el
     1º par cuesta $899 y paga envío; el 2º par lo lleva a envío gratis. Cada
     par es de 2 productos distintos. Después de los 2 pares, lo que se agregue
     va como frasco extra al 50%. */
  var SUB_PARES = 4;
  var SUB_MAX = SUB_FRASCOS * SUB_PARES;

  function dinero(centavos) {
    return '$' + (centavos / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function llenar(texto, datos) {
    return String(texto || '').replace(/\{(\w+)\}/g, function (_, k) {
      return datos[k] !== undefined ? datos[k] : '';
    });
  }

  /* Mismo camino que el buy box de las fichas: XHR. Appstle envuelve
     window.fetch y borra el selling_plan del /cart/add; a XHR no lo toca. */
  function porXHR(url, cuerpo) {
    return new Promise(function (resolve) {
      var x = new XMLHttpRequest();
      x.open('POST', url, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        var d = {};
        try { d = JSON.parse(x.responseText); } catch (e) {}
        resolve({ ok: x.status >= 200 && x.status < 300, cuerpo: d });
      };
      x.onerror = function () { resolve({ ok: false, cuerpo: {} }); };
      x.send(cuerpo);
    });
  }

  var _fetchLimpio = null;
  function fetchLimpio() {
    if (_fetchLimpio) return _fetchLimpio;
    try {
      var marco = document.createElement('iframe');
      marco.style.display = 'none';
      marco.setAttribute('aria-hidden', 'true');
      document.documentElement.appendChild(marco);
      _fetchLimpio = marco.contentWindow.fetch.bind(marco.contentWindow);
    } catch (e) {
      _fetchLimpio = window.fetch.bind(window);
    }
    return _fetchLimpio;
  }

  function iniciar(raiz) {
    if (raiz.dataset.apListo) return;
    raiz.dataset.apListo = '1';

    var T = {};
    try { T = JSON.parse(raiz.querySelector('[data-ap-textos]').textContent); } catch (e) {}

    var ENVIO_MIN = parseInt(raiz.dataset.envioMin, 10) || 99800;
    var ENVIO_COSTO = parseInt(raiz.dataset.envioCosto, 10) || 10000;
    /* 0 o vacío = sin tope: cada frasco extra al 50%, los que quieran. */
    var MAX_EXTRAS = parseInt(raiz.dataset.maxExtras, 10) || Infinity;

    function leerPlanes(crudo) {
      var mapa = {};
      try {
        (JSON.parse(crudo || '[]') || []).forEach(function (pl) { mapa[pl.nombre] = pl; });
      } catch (e) {}
      return mapa;
    }

    var productos = {};
    var orden = [];
    raiz.querySelectorAll('[data-ap-prod]').forEach(function (el) {
      var d = el.dataset;
      var p = {
        id: d.apProd,
        el: el,
        nombre: d.nombre,
        foto: d.foto,
        onceId: d.onceId,
        oncePrecio: parseInt(d.oncePrecio, 10) || 0,
        regaloId: d.regaloId,
        subId: d.subId,
        subPrecio: parseInt(d.subPrecio, 10) || 0,
        subAntes: parseInt(d.subAntes, 10) || 0,
        plan: d.plan,
        compId: d.compId,
        compPrecio: parseInt(d.compPrecio, 10) || 0,
        compAntes: parseInt(d.compAntes, 10) || 0,
        hayOnce: d.hayOnce === 'true',
        haySub: d.haySub === 'true',
        planes: leerPlanes(d.planes),
        hayComp: d.hayComp === 'true'
      };
      productos[p.id] = p;
      orden.push(p.id);
    });

    /* El pack es su propia oferta (la de /products/pack-del-amor): opciones y
       precios vienen del Liquid, leídos de sus variantes y planes. No llena
       las casillas del constructor. */
    var packs = [];
    raiz.querySelectorAll('[data-ap-pack]').forEach(function (el) {
      var ops = [];
      try { ops = JSON.parse(el.querySelector('[data-ap-pack-data]').textContent) || []; } catch (e) {}
      if (!ops.length) { el.hidden = true; return; }
      var incluye = String(el.dataset.incluye || '').split(',')
        .map(function (x) { return x.trim(); })
        .filter(function (x) { return productos[x]; });
      var pk = { el: el, ops: ops, incluye: incluye, boton: el.querySelector('[data-ap-pack-cta]').textContent, sel: {} };
      ['once', 'sub'].forEach(function (m) {
        for (var i = 0; i < ops.length; i++) {
          if (ops[i].modo === m) { pk.sel[m] = i; break; }
        }
      });
      packs.push(pk);
    });

    /* Índice de la casilla que se acaba de llenar, para que dé el saltito y
       el cliente vea DÓNDE cayó su frasco. */
    var recienLlena = null;

    var estado = {
      /* En suscripción, con el 1er 2x1 completo, el cliente decide qué suma
         lo siguiente que toque: otro 2x1 (envío gratis) o un frasco al 50%. */
      agregando: '2x1',
      modo: raiz.dataset.modo === 'once' ? 'once' : 'sub',
      frascos: [],
      extras: [],
      upsellVisto: { once: false, sub: false },
      plan: raiz.dataset.planInicial || ''
    };

    /* Precio y plan de la suscripción según la frecuencia elegida. */
    function planDe(p) {
      return p.planes[estado.plan] || null;
    }
    function precioSub(p) {
      var pl = planDe(p);
      return pl ? pl.precio : 0;
    }
    function cadaTexto() {
      return llenar(T.every, { plan: estado.plan });
    }

    function disponible(p, modo) {
      return modo === 'once' ? p.hayOnce : (p.haySub && !!planDe(p));
    }

    /* En suscripción el 2x1 es de DOS PRODUCTOS DISTINTOS (decisión de
       Carlos, 2026-09-18): Seeds + Honey sí, Seeds + Seeds no. Un producto que
       ya está en la suscripción solo puede volver a entrar como frasco extra
       al 50%, que es de compra única y no se suma al contrato. */
    function repetidoEnSub(id) {
      /* (2026-09-22) Un solo 2x1 por producto en la suscripción: si ya tiene
         Seeds, el siguiente 2x1 es de Honey o de Rebira. Así cada contrato
         lleva a lo más 2 frascos de cada uno y no se atrasan las entregas. */
      return estado.modo === 'sub' && estado.frascos.indexOf(id) !== -1;
    }

    /* Productos que todavía pueden entrar como 2x1 en la suscripción. */
    function quedanSub() {
      return orden.filter(function (id) {
        return disponible(productos[id], 'sub') && estado.frascos.indexOf(id) === -1;
      });
    }

    function limite() {
      return estado.modo === 'once' ? MAX_ONCE : SUB_MAX;
    }

    function cuantos(id) {
      return estado.frascos.filter(function (x) { return x === id; }).length;
    }

    /* ── cuentas ── */
    /* Los frascos extra al 50% van aparte de la promoción: se suman al final,
       cada uno a su precio de complemento. */
    function sumarExtras(r) {
      estado.extras.forEach(function (id) {
        var e = productos[id];
        r.total += e.compPrecio;
        r.antes += e.compAntes;
      });
    }

    function cuantosExtra(id) {
      return estado.extras.filter(function (x) { return x === id; }).length;
    }

    function calcular() {
      var n = estado.frascos.length;
      var r = { n: n, total: 0, antes: 0, listo: false, faltan: 0, envioGratis: false };

      if (estado.modo === 'once') {
        var gratis = Math.floor(n / 3);
        estado.frascos.forEach(function (id, i) {
          var p = productos[id];
          r.antes += p.oncePrecio;
          if (i % 3 !== 2) r.total += p.oncePrecio;
        });
        r.gratis = gratis;
        /* El frasco extra al 50% va aparte del 3x2: no entra en la cuenta de
           los que van gratis, se suma al final como una compra más. */
        sumarExtras(r);
        r.listo = n >= MIN_ONCE;
        r.faltan = n < MIN_ONCE ? MIN_ONCE - n : (n % 3 === 0 ? 0 : 3 - (n % 3));
      } else {
        estado.frascos.forEach(function (id) {
          var p = productos[id];
          r.total += precioSub(p);
          r.antes += p.subAntes;
        });
        r.recurrente = r.total;
        r.ahorroRecurrente = r.antes - r.total;
        sumarExtras(r);
        r.listo = n > 0 && n % 2 === 0;
        r.faltan = n === 0 ? SUB_FRASCOS : n % 2;
        r.pares = Math.floor(n / 2);
      }
      r.ahorro = r.antes - r.total;
      r.envioGratis = r.total >= ENVIO_MIN;
      return r;
    }

    /* ── pintar ── */
    function pintarModos() {
      raiz.querySelectorAll('[data-ap-modo]').forEach(function (b) {
        b.setAttribute('aria-selected', b.dataset.apModo === estado.modo ? 'true' : 'false');
      });
      raiz.dataset.modo = estado.modo;
    }

    /* Precio corto para las casillas: sin «.00» cuando es cerrado. */
    function corto(centavos) {
      return centavos % 100 === 0
        ? '$' + (centavos / 100).toLocaleString('es-MX')
        : dinero(centavos);
    }

    /* `precio` = { paga, antes } en centavos. Va debajo del nombre para que el
       cliente vea qué suma cada frasco y dónde está el descuento. */
    function casilla(id, etiqueta, esGratis, clase, precio) {
      var li = document.createElement('li');
      li.className = 'ms-ap__slot' + (clase ? ' ' + clase : '');
      if (esGratis) {
        var g = document.createElement('span');
        g.className = 'ms-ap__slot-free';
        g.textContent = esGratis;
        li.appendChild(g);
      }
      if (id) {
        var p = productos[id];
        li.classList.add('is-on');
        if (p.foto) {
          var img = document.createElement('img');
          img.src = p.foto;
          img.alt = '';
          img.loading = 'lazy';
          li.appendChild(img);
        }
        var nom = document.createElement('span');
        nom.className = 'ms-ap__slot-name';
        nom.textContent = p.nombre;
        li.appendChild(nom);
        if (precio) {
          var pr = document.createElement('span');
          pr.className = 'ms-ap__slot-price';
          var paga = document.createElement('b');
          paga.textContent = corto(precio.paga);
          pr.appendChild(paga);
          if (precio.antes > precio.paga) {
            var tach = document.createElement('s');
            tach.textContent = corto(precio.antes);
            pr.appendChild(tach);
          }
          li.appendChild(pr);
        }
      } else {
        var vacio = document.createElement('span');
        vacio.textContent = etiqueta;
        li.appendChild(vacio);
      }
      return li;
    }

    /* Las casillas de los frascos extra al 50%: una por cada extra ya puesto
       y, si todavía caben, una vacía con el «+». Iguales en los dos modos. */
    function casillasExtra(activa) {
      var lis = [];
      estado.extras.forEach(function (id, k) {
        var pe = productos[id];
        var li = casilla(id, '', '50%', 'ms-ap__slot--up', { paga: pe.compPrecio, antes: pe.compAntes });
        var una = document.createElement('span');
        una.style.fontSize = '10.5px';
        una.textContent = T.upsellOnce;
        li.appendChild(una);
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'ms-ap__slot-x';
        x.setAttribute('aria-label', 'Quitar frasco extra');
        x.textContent = '×';
        x.addEventListener('click', function (e) {
          e.stopPropagation();
          estado.extras.splice(k, 1);
          pintar();
        });
        li.appendChild(x);
        lis.push(li);
      });
      if (estado.extras.length < MAX_EXTRAS) {
        var up = casilla(null, T.upsellSlot, '', 'ms-ap__slot--up');
        up.innerHTML = '';
        var mas = document.createElement('span');
        mas.className = 'ms-ap__slot-plus';
        mas.textContent = '+';
        var txt = document.createElement('span');
        txt.textContent = T.upsellSlot;
        up.appendChild(mas);
        up.appendChild(txt);
        up.setAttribute('role', 'button');
        up.setAttribute('tabindex', activa ? '0' : '-1');
        up.setAttribute('aria-disabled', activa ? 'false' : 'true');
        up.addEventListener('click', function () {
          if (!activa) return;
          if (estado.modo === 'sub') { estado.agregando = '50'; pintar(); return; }
          abrirUpsell('50');
        });
        lis.push(up);
      }
      return lis;
    }

    /* «Mejor oferta» y el sello de envío gratis siempre: van en la opción del
       2x1, en el panel y en la ventana. */
    function etiquetaMejor() {
      var e = document.createElement('span');
      e.className = 'ms-ap__mejor';
      e.textContent = T.opc2x1Tag;
      return e;
    }
    function sello() {
      var e = document.createElement('span');
      e.className = 'ms-ap__sello';
      e.textContent = T.opc2x1Envio;
      return e;
    }

    /* Las dos opciones, con el mismo peso: otro 2x1 o un frasco al 50%. */
    function selectorSiguiente(r) {
      var li = document.createElement('li');
      li.className = 'ms-ap__elige';
      var t = document.createElement('p');
      t.className = 'ms-ap__elige-titulo';
      t.textContent = T.eligeTitulo;
      li.appendChild(t);
      var caja = document.createElement('div');
      caja.className = 'ms-ap__elige-ops';
      var gratisYa = r.total >= ENVIO_MIN;
      [
        { v: '2x1', a: T.opc2x1, b: gratisYa ? T.opc2x1SubFree : T.opc2x1Sub, off: r.n >= SUB_MAX },
        { v: '50', a: T.opc50, b: T.opc50Sub, off: estado.extras.length >= MAX_EXTRAS }
      ].forEach(function (o) {
        var bt = document.createElement('button');
        bt.type = 'button';
        bt.className = 'ms-ap__elige-op' + (estado.agregando === o.v ? ' is-on' : '') + (o.v === '2x1' ? ' is-top' : '');
        bt.setAttribute('aria-pressed', estado.agregando === o.v ? 'true' : 'false');
        bt.disabled = o.off;
        if (o.v === '2x1') bt.appendChild(etiquetaMejor());
        var s1 = document.createElement('strong'); s1.textContent = o.a;
        var s2 = document.createElement('span'); s2.textContent = o.b;
        bt.appendChild(s1); bt.appendChild(s2);
        if (o.v === '2x1') bt.appendChild(sello());
        bt.addEventListener('click', function () { estado.agregando = o.v; pintar(); });
        caja.appendChild(bt);
      });
      li.appendChild(caja);
      return li;
    }

    function pintarPanel(r) {
      var once = estado.modo === 'once';
      raiz.querySelector('[data-ap-kicker]').textContent = once ? T.onceKicker : T.subKicker;
      raiz.querySelector('[data-ap-titulo]').textContent = once ? T.onceTitle : T.subTitle;

      var pista = once ? T.hintOnce : T.hintSub;
      if (once && r.n >= MIN_ONCE && r.faltan > 0 && r.n + r.faltan <= MAX_ONCE) {
        pista = llenar(T.hintOnceMore, { n: r.faltan });
      }
      if (!once && r.n >= SUB_FRASCOS) {
        pista = !quedanSub().length && T.hintSubTodos ? T.hintSubTodos : (r.envioGratis && T.hintSub3 ? T.hintSub3 : T.hintSub2);
      }
      raiz.querySelector('[data-ap-pista]').textContent = pista;

      var lista = raiz.querySelector('[data-ap-slots]');
      lista.innerHTML = '';

      if (once) {
        var casillas = Math.min(MAX_ONCE, Math.max(MIN_ONCE, Math.ceil(r.n / 3) * 3));
        for (var i = 0; i < casillas; i++) {
          var id = estado.frascos[i];
          var po = id ? productos[id] : null;
          var li = casilla(id, llenar(T.empty, { n: i + 1 }), i % 3 === 2 ? T.free : '', '',
            po ? { paga: i % 3 === 2 ? 0 : po.oncePrecio, antes: po.oncePrecio } : null);
          if (id) li.appendChild(botonQuitar(i));
          if (i === recienLlena) li.classList.add('is-nueva');
          lista.appendChild(li);
        }
        /* Con el 3x2 ya completo, el frasco a mitad de precio es mejor oferta
           que pedirle otros tres: se le ofrece aquí mismo. */
        if (r.n >= MIN_ONCE) casillasExtra(true).forEach(function (li) { lista.appendChild(li); });
      } else {
        /* Cada 2x1 va en su propio recuadro («Tu 2x1», «2º 2x1 · envío
           gratis»…) para que se vea que está armando otro 2x1. Con uno
           completo aparece el selector: otro 2x1 o frasco al 50%. */
        var completos = Math.floor(r.n / 2);
        var pares = Math.max(1, Math.ceil(r.n / 2));
        if (r.n % 2 === 0 && r.n > 0 && r.n < SUB_MAX && quedanSub().length) pares += 1;

        /* Los 3 pasos, siempre a la vista: quien se distrae sabe dónde va. */
        var pasos = document.createElement('li');
        pasos.className = 'ms-ap__pasos';
        [
          { t: T.paso1, ok: completos >= 1, on: completos === 0 },
          { t: T.paso2, ok: completos >= 2, on: completos === 1 },
          { t: T.paso3, ok: false, on: completos >= 2 }
        ].forEach(function (ps, iP) {
          var e = document.createElement('span');
          e.className = 'ms-ap__paso' + (ps.ok ? ' is-ok' : '') + (ps.on ? ' is-on' : '');
          var nn = document.createElement('b');
          nn.textContent = ps.ok ? '✓' : String(iP + 1);
          e.appendChild(nn);
          e.appendChild(document.createTextNode(ps.t));
          pasos.appendChild(e);
        });
        lista.appendChild(pasos);

        for (var k = 0; k < pares; k++) {
          var pid = estado.frascos[k * 2];
          var pp = pid ? productos[pid] : null;
          var grupo = document.createElement('li');
          grupo.className = 'ms-ap__par' + (pp ? ' is-lleno' : ' is-abierto') + (k > 0 ? ' is-extra' : '');
          if (k * 2 + 1 === recienLlena) grupo.classList.add('is-nueva');
          var cab = document.createElement('p');
          cab.className = 'ms-ap__par-titulo';
          cab.textContent = pp
            ? llenar(k === 0 ? T.par1Lleno : T.parNLleno, { producto: pp.nombre, n: k + 1 })
            : (k === 0 ? T.par1 : llenar(k === 1 ? T.par2 : T.parN, { n: k + 1 }));
          grupo.appendChild(cab);
          if (pp) {
            var fila = document.createElement('div');
            fila.className = 'ms-ap__par-fila';
            [T.parPagas, T.free].forEach(function (etq, iF) {
              var fr = document.createElement('span');
              fr.className = 'ms-ap__par-frasco' + (iF ? ' is-gratis' : '');
              if (pp.foto) { var im = document.createElement('img'); im.src = pp.foto; im.alt = ''; fr.appendChild(im); }
              var bb = document.createElement('b'); bb.textContent = etq; fr.appendChild(bb);
              fila.appendChild(fr);
              if (!iF) { var mas = document.createElement('span'); mas.className = 'ms-ap__par-mas'; mas.textContent = '+'; fila.appendChild(mas); }
            });
            grupo.appendChild(fila);
            var pr2 = document.createElement('p');
            pr2.className = 'ms-ap__par-precio';
            var b1 = document.createElement('b'); b1.textContent = corto(precioSub(pp) * 2); pr2.appendChild(b1);
            if (pp.subAntes * 2 > precioSub(pp) * 2) { var s1 = document.createElement('s'); s1.textContent = corto(pp.subAntes * 2); pr2.appendChild(s1); }
            pr2.appendChild(document.createTextNode(' ' + T.parPrecio));
            grupo.appendChild(pr2);
            grupo.appendChild(botonQuitar(k * 2));
          } else {
            var vacio = document.createElement('p');
            vacio.className = 'ms-ap__par-vacio';
            vacio.textContent = T.parVacio;
            grupo.appendChild(vacio);
          }
          lista.appendChild(grupo);
        }

      }

      recienLlena = null;


      raiz.querySelector('[data-ap-total]').textContent = dinero(r.total);

      var antes = raiz.querySelector('[data-ap-antes]');
      antes.hidden = !(r.ahorro > 0);
      antes.textContent = dinero(r.antes);

      var ahorro = raiz.querySelector('[data-ap-ahorro]');
      if (!once && r.ahorroRecurrente > 0) {
        ahorro.hidden = false;
        ahorro.textContent = llenar(T.saveSub, { monto: dinero(r.ahorroRecurrente) });
      } else if (r.ahorro > 0) {
        ahorro.hidden = false;
        ahorro.textContent = llenar(T.save, { monto: dinero(r.ahorro) });
      } else {
        ahorro.hidden = true;
      }

      var envio = raiz.querySelector('[data-ap-envio]');
      envio.innerHTML = '';
      if (r.n > 0) {
        if (r.envioGratis) {
          var st = document.createElement('strong');
          st.textContent = !once && T.shipFreeSub ? T.shipFreeSub : T.shipFree;
          envio.appendChild(st);
        } else {
          envio.textContent = llenar(T.shipPaid, { costo: dinero(ENVIO_COSTO) });
        }
      }

      /* Comparativa contra la suscripción: el precio por frasco de SU selección
         en compra única frente al del 2x1 de esos mismos productos. Solo se
         enseña si de verdad sale más barato suscrito. */
      var vs = raiz.querySelector('[data-ap-vs]');
      if (vs) {
        var mostrar = false;
        if (once && r.n > 0) {
          var subs = estado.frascos.filter(function (id) { return disponible(productos[id], 'sub'); });
          if (subs.length) {
            var subPorFrasco = subs.reduce(function (t, id) { return t + precioSub(productos[id]); }, 0) / subs.length;
            var oncePorFrasco = r.total / r.n;
            var dif = oncePorFrasco - subPorFrasco;
            if (dif > 0) {
              mostrar = true;
              vs.querySelector('[data-ap-vs-once]').textContent = dinero(Math.round(oncePorFrasco));
              vs.querySelector('[data-ap-vs-sub]').textContent = dinero(Math.round(subPorFrasco));
              vs.querySelector('[data-ap-vs-ahorro]').textContent = llenar(T.vsSave, { monto: dinero(Math.round(dif)) });
            }
          }
        }
        vs.hidden = !mostrar;
      }

      /* Con el frasco extra el total de hoy y el recurrente dejan de ser el
         mismo número. Se dicen los dos: nadie debe descubrir el cobro de los
         siguientes envíos en su estado de cuenta. */
      var nota = once ? T.noteOnce : llenar(T.noteSub, { cada: cadaTexto() });
      if (once && estado.extras.length && T.noteOnceUpsell) nota = T.noteOnceUpsell;
      if (!once && estado.extras.length && T.noteSubUpsell) {
        nota = llenar(T.noteSubUpsell, { hoy: dinero(r.total), despues: dinero(r.recurrente), cada: cadaTexto() });
      }
      raiz.querySelector('[data-ap-nota]').textContent = nota;

      var textoCta;
      if (r.n === 0) textoCta = T.ctaEmpty;
      else if (!r.listo) textoCta = llenar(T.ctaMissing, { n: r.faltan });
      else if (once) textoCta = llenar(T.ctaOnce, { total: dinero(r.total) });
      else textoCta = llenar(T.ctaSub, { total: dinero(r.recurrente) + ' ' + cadaTexto() });

      /* En la barra de celular el total ya está a la izquierda: el botón va
         corto para no partirse en dos líneas. */
      var textoDock = !r.listo ? textoCta : (once ? T.ctaDockOnce : T.ctaDockSub) || textoCta;

      raiz.querySelectorAll('[data-ap-cta]').forEach(function (b) {
        if (b.classList.contains('is-done') || b.getAttribute('aria-busy') === 'true') return;
        b.disabled = !r.listo;
        b.textContent = b.classList.contains('ms-ap__cta--dock') ? textoDock : textoCta;
      });

      var dock = raiz.querySelector('[data-ap-dock]');
      dock.hidden = r.n === 0;
      raiz.querySelector('[data-ap-dock-cuenta]').textContent =
        once ? r.n + (r.n === 1 ? ' frasco' : ' frascos') + (r.gratis ? ' · ' + r.gratis + ' gratis' : '')
             : r.n + (r.n === 1 ? ' frasco' : ' frascos') + (r.pares > 1 ? ' · ' + r.pares + ' veces 2x1' : '') + (estado.extras.length ? ' + ' + estado.extras.length + ' al 50%' : '');
      raiz.querySelector('[data-ap-dock-total]').textContent = dinero(r.total);
    }

    function botonQuitar(indice) {
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'ms-ap__slot-x';
      x.setAttribute('aria-label', 'Quitar');
      x.textContent = '×';
      x.addEventListener('click', function () {
        if (estado.modo === 'sub') estado.frascos.splice(indice - (indice % 2), 2);
        else estado.frascos.splice(indice, 1);
        pintar();
      });
      return x;
    }

    /* ¿Este toque agrega el frasco extra al 50%? Pasa en suscripción cuando
       los 2 frascos ya están puestos: el selector NO se bloquea, porque si el
       cliente cerró la ventana del upsell esa era la única forma de agregarlo
       y quedaba encerrado. */
    function tocaExtra(p) {
      if (!p.hayComp || estado.extras.length >= MAX_EXTRAS) return false;
      /* Con la promoción ya completa (2 en suscripción, 3 en compra única)
         cada frasco más entra como extra al 50%. */
      /* (2026-09-22) En suscripción ya no hay frasco al 50%: solo otro 2x1. */
      if (estado.modo === 'sub') return false;
      return estado.frascos.length >= MIN_ONCE;
    }

    function pintarTarjetas() {
      var lleno = estado.frascos.length >= limite();
      orden.forEach(function (id) {
        var p = productos[id];
        var n = cuantos(id) + cuantosExtra(id);
        var hay = disponible(p, estado.modo) || (estado.modo === 'sub' && p.hayComp);
        var el = p.el;
        var extra = tocaExtra(p);

        el.classList.toggle('is-on', n > 0);
        el.classList.toggle('is-agotado', !hay);

        var precio = el.querySelector('[data-ap-precio]');
        precio.innerHTML = '';
        if (estado.modo === 'once') {
          precio.appendChild(document.createTextNode(dinero(p.oncePrecio)));
        } else {
          /* En suscripción la tarjeta vende el 2x1 entero: 2 frascos, 1 precio. */
          precio.appendChild(document.createTextNode(corto(precioSub(p) * 2)));
          if (p.subAntes > precioSub(p)) {
            var s = document.createElement('s');
            s.textContent = corto(p.subAntes * 2);
            precio.appendChild(s);
          }
          var sm = document.createElement('small');
          sm.textContent = T.cardSub;
          precio.appendChild(sm);
        }

        var cuenta = el.querySelector('[data-ap-cuenta]');
        cuenta.hidden = n === 0;
        cuenta.textContent = '×' + n;

        var agregar = el.querySelector('[data-ap-agregar]');
        var stepper = el.querySelector('[data-ap-stepper]');
        var agotado = el.querySelector('[data-ap-agotado]');

        agotado.hidden = hay;
        agregar.hidden = !hay || n > 0;
        stepper.hidden = !hay || n === 0;

        agregar.disabled = lleno && !extra;
        var al2x1 = estado.modo === 'sub' && !extra && !lleno;
        agregar.textContent = extra ? T.addExtra : (lleno ? T.full : (al2x1 ? llenar(T.cardSubBtn, { producto: p.nombre }) : (el.dataset.textoAgregar || agregar.textContent)));
        el.querySelector('[data-ap-n]').textContent = n;
        var repetido = repetidoEnSub(id);
        el.querySelector('[data-ap-mas]').disabled = (lleno && !extra) || repetido;
        el.querySelector('[data-ap-mas]').setAttribute('title', repetido ? T.subOtro : (extra ? T.addExtra : ''));

        /* Aviso en la tarjeta: por qué su «+» está apagado. */
        var aviso = el.querySelector('.ms-ap__prod-aviso');
        if (!aviso) {
          aviso = document.createElement('p');
          aviso.className = 'ms-ap__prod-aviso';
          el.querySelector('.ms-ap__prod-actions').appendChild(aviso);
        }
        aviso.hidden = !repetido;
        aviso.textContent = T.subOtro;
      });
    }

    function opcionPack(pk) {
      var i = pk.sel[estado.modo];
      return i === undefined ? null : pk.ops[i];
    }

    function pintarPacks() {
      packs.forEach(function (pk) {
        var el = pk.el;
        var modo = estado.modo;
        /* Agotado = el de las tarjetas reales de Seeds y Honey. */
        var hay = pk.incluye.every(function (id) { return productos[id].hayOnce || productos[id].haySub; });
        var op = opcionPack(pk);
        if (!op) hay = false;

        el.classList.toggle('is-agotado', !hay);
        el.querySelector('[data-ap-agotado]').hidden = hay;

        var lista = el.querySelector('[data-ap-pack-opts]');
        lista.innerHTML = '';
        pk.ops.forEach(function (o, i) {
          if (o.modo !== modo) return;
          var fila = document.createElement('button');
          fila.type = 'button';
          fila.className = 'ms-ap__pack-opt' + (pk.sel[modo] === i ? ' is-on' : '');
          fila.setAttribute('role', 'radio');
          fila.setAttribute('aria-checked', pk.sel[modo] === i ? 'true' : 'false');

          var izq = document.createElement('span');
          izq.className = 'ms-ap__pack-opt-name';
          izq.textContent = o.nombre;
          if (o.badge) {
            var bd = document.createElement('em');
            bd.textContent = o.badge;
            izq.appendChild(bd);
          }
          if (o.nota) {
            var nt = document.createElement('small');
            nt.textContent = o.nota;
            izq.appendChild(nt);
          }

          var der = document.createElement('span');
          der.className = 'ms-ap__pack-opt-price';
          der.textContent = dinero(o.total);
          if (o.antes > o.total) {
            var s = document.createElement('s');
            s.textContent = dinero(o.antes);
            der.appendChild(s);
          }

          fila.appendChild(izq);
          fila.appendChild(der);
          fila.addEventListener('click', function () {
            pk.sel[modo] = i;
            pintarPacks();
          });
          lista.appendChild(fila);
        });

        var boton = el.querySelector('[data-ap-pack-cta]');
        var nota = el.querySelector('[data-ap-pack-nota]');
        boton.hidden = !hay;
        if (!op || boton.getAttribute('aria-busy') === 'true' || boton.classList.contains('is-done')) return;

        boton.disabled = false;
        boton.textContent = modo === 'sub'
          ? llenar(T.packCtaSub, { total: dinero(op.total), plan: op.planNombre })
          : llenar(T.packCtaOnce, { total: dinero(op.total) });

        var ahorro = op.antes - op.total;
        nota.textContent = ahorro > 0
          ? llenar(modo === 'sub' ? T.saveSub : T.save, { monto: dinero(ahorro) })
          : '';
      });
    }

    /* Orden de las frecuencias = el de «plan_names» (lo trae el primer
       producto que las tenga todas). */
    function frecuencias() {
      var nombres = [];
      orden.forEach(function (id) {
        Object.keys(productos[id].planes).forEach(function (n) {
          if (nombres.indexOf(n) === -1) nombres.push(n);
        });
      });
      return nombres;
    }

    function pintarFrecuencia() {
      var caja = raiz.querySelector('[data-ap-freq]');
      if (!caja) return;
      var nombres = frecuencias();
      caja.hidden = estado.modo !== 'sub' || nombres.length < 2;
      if (caja.hidden) return;

      /* El precio de la píldora: el de 2 frascos de lo que ya eligió, o del
         primer producto disponible si todavía no elige nada. */
      var base = estado.frascos.length ? estado.frascos.slice(0, SUB_FRASCOS) : [];
      var lista = caja.querySelector('[data-ap-freq-opts]');
      lista.innerHTML = '';
      nombres.forEach(function (n) {
        var total = 0;
        var ok = true;
        if (base.length) {
          base.forEach(function (id) {
            var pl = productos[id].planes[n];
            if (!pl) ok = false; else total += pl.precio;
          });
          if (base.length === 1) total = total * 2;
        } else {
          var primero = orden.filter(function (id) { return productos[id].haySub && productos[id].planes[n]; })[0];
          if (!primero) ok = false; else total = productos[primero].planes[n].precio * 2;
        }
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ms-ap__freq-opt' + (estado.plan === n ? ' is-on' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', estado.plan === n ? 'true' : 'false');
        b.disabled = !ok;
        var t1 = document.createElement('span');
        t1.className = 'ms-ap__freq-name';
        var etiqueta = llenar(T.every, { plan: n });
        t1.textContent = etiqueta.charAt(0).toUpperCase() + etiqueta.slice(1);
        var t2 = document.createElement('span');
        t2.className = 'ms-ap__freq-price';
        t2.textContent = ok ? llenar(T.freqPrice, { precio: dinero(total) }) : '';
        b.appendChild(t1);
        b.appendChild(t2);
        b.addEventListener('click', function () {
          estado.plan = n;
          pintar();
        });
        lista.appendChild(b);
      });
    }

    function pintar() {
      /* Si un frasco elegido no existe en este modo (agotado), se suelta. */
      estado.frascos = estado.frascos.filter(function (id) { return disponible(productos[id], estado.modo); });
      if (estado.frascos.length > limite()) estado.frascos = estado.frascos.slice(0, limite());
      if (estado.modo === 'sub') {
        /* (2026-09-21) Cada toque en suscripción mete el 2x1 COMPLETO de ese
           producto: 2 Seeds, 2 Rebira… Al venir de compra única se toma un
           producto por par (el 1º, 3º, 5º…) y se dobla. */
        var acomodados = [];
        for (var q = 0; q < estado.frascos.length && acomodados.length < SUB_MAX; q += 2) {
          if (acomodados.indexOf(estado.frascos[q]) !== -1) continue;
          acomodados.push(estado.frascos[q], estado.frascos[q]);
        }
        estado.frascos = acomodados;
        estado.extras = [];
        estado.agregando = '2x1';
      }
      if (estado.frascos.length < SUB_FRASCOS) estado.agregando = '2x1';
      var minimo = estado.modo === 'sub' ? SUB_FRASCOS : MIN_ONCE;
      if (estado.frascos.length < minimo) estado.extras = [];
      estado.extras = estado.extras.filter(function (id) { return productos[id].hayComp; }).slice(0, MAX_EXTRAS);

      pintarModos();
      pintarFrecuencia();
      pintarTarjetas();
      pintarPacks();
      pintarPanel(calcular());
    }

    /* ── upsell ── */
    var modal = raiz.querySelector('[data-ap-upsell]');

    var modalTag = modal.querySelector('[data-ap-up-tag]');
    var modalTitulo = modal.querySelector('[data-ap-up-titulo]');
    var modalOtro = modal.querySelector('[data-ap-up-otro]');
    var textosModal = { tag: modalTag.textContent, titulo: modalTitulo.textContent, no: (modal.querySelector('.ms-ap__modal-no') || {}).textContent };

    function mostrarModal(lista) {
      estado.upsellVisto[estado.modo] = true;
      if (modal.hidden) {
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      var primero = lista.querySelector('button:not([disabled])');
      if (primero) primero.focus();
    }

    /* Al completar el 1er 2x1: la ventana no empuja un solo camino, pone las
       dos opciones lado a lado y el cliente escoge. Después elige los frascos
       desde las tarjetas y los ve caer en su recuadro. */
    function abrirEleccion() {
      var r = calcular();
      if (!quedanSub().length) return;
      var lista = modal.querySelector('[data-ap-up-lista]');
      lista.innerHTML = '';
      if (modalOtro) modalOtro.hidden = true;
      var primero = productos[estado.frascos[0]];
      var botonNo = modal.querySelector('.ms-ap__modal-no');
      if (botonNo && T.subDecline) botonNo.textContent = T.subDecline;
      modalTag.textContent = T.sub2Tag;
      modalTitulo.textContent = llenar(T.eligeModalTitulo, { producto: primero ? primero.nombre : '' });
      modal.querySelector('[data-ap-up-texto]').textContent = llenar(T.eligeModalTexto, { cada: cadaTexto() });
      var ejemplo = productos[orden.filter(function (id) { return disponible(productos[id], 'sub'); })[0]];
      var precioPar = ejemplo ? precioSub(ejemplo) * 2 : 0;
      var precio50 = ejemplo ? ejemplo.compPrecio : 0;
      [
        { v: '2x1', a: T.opc2x1, b: llenar(T.opc2x1Modal, { precio: dinero(precioPar), total: dinero(r.recurrente + precioPar), cada: cadaTexto() }), btn: T.opc2x1Btn },
      ].forEach(function (o) {
        var card = document.createElement('div');
        card.className = 'ms-ap__up ms-ap__up--op ms-ap__up--solo' + (o.v === '2x1' ? ' is-destacado' : '');
        var nom = document.createElement('span');
        nom.className = 'ms-ap__up-name';
        nom.textContent = o.a;
        if (o.v === '2x1') card.appendChild(etiquetaMejor());
        card.appendChild(nom);
        if (o.v === '2x1') card.appendChild(sello());
        if (o.grande) {
          var gp = document.createElement('span');
          gp.className = 'ms-ap__up-grande';
          gp.textContent = o.grande;
          if (o.antes) { var gs = document.createElement('s'); gs.textContent = o.antes; gp.appendChild(gs); }
          card.appendChild(gp);
        }
        var d = document.createElement('span');
        d.className = 'ms-ap__up-desc';
        d.textContent = o.b;
        card.appendChild(d);
        if (o.v === '2x1' && T.opc2x1Elige) {
          var el2 = document.createElement('span');
          el2.className = 'ms-ap__up-elige';
          el2.textContent = T.opc2x1Elige;
          card.appendChild(el2);
        }
        if (o.v === '2x1') {
          /* Un toque y el 2x1 de ese producto ya está en su pedido. */
          var chips = document.createElement('div');
          chips.className = 'ms-ap__up-chips';
          quedanSub().forEach(function (id) {
            var p = productos[id];
            var ch = document.createElement('button');
            ch.type = 'button';
            ch.className = 'ms-ap__up-chip';
            if (p.foto) { var im = document.createElement('img'); im.src = p.foto; im.alt = ''; ch.appendChild(im); }
            var tx = document.createElement('span'); tx.textContent = llenar(T.opc2x1Chip, { producto: p.nombre }); ch.appendChild(tx);
            ch.addEventListener('click', function () {
              estado.agregando = '2x1';
              cerrarUpsell();
              agregarFrasco(id);
            });
            chips.appendChild(ch);
          });
          card.appendChild(chips);
          lista.appendChild(card);
          return;
        }
        var bt = document.createElement('button');
        bt.type = 'button';
        bt.textContent = o.btn;
        bt.addEventListener('click', function () {
          estado.agregando = o.v;
          cerrarUpsell();
          pintar();
          var tarjetas = raiz.querySelector('[data-ap-prod]');
          if (tarjetas && window.innerWidth >= 750) tarjetas.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        card.appendChild(bt);
        lista.appendChild(card);
      });
      mostrarModal(lista);
    }

    function abrirUpsell(tipo) {
      if (estado.modo === 'sub' && tipo !== '50') { abrirEleccion(); return; }
      if (estado.extras.length >= MAX_EXTRAS) return;
      var r = calcular();
      var lista = modal.querySelector('[data-ap-up-lista]');
      lista.innerHTML = '';
      modalTag.textContent = textosModal.tag;
      var botonNo1 = modal.querySelector('.ms-ap__modal-no');
      if (botonNo1 && textosModal.no) botonNo1.textContent = textosModal.no;
      modalTitulo.textContent = textosModal.titulo;
      if (modalOtro) modalOtro.hidden = true;

      var candidatos = orden.filter(function (id) { return productos[id].hayComp; });
      if (!candidatos.length) return;

      /* El texto dice la verdad sobre SU pedido: si ya tenía envío gratis, no
         se lo promete como novedad. Se calcula con el primer candidato; todos
         cuestan lo mismo. */
      var ejemplo = productos[candidatos[0]];
      var totalCon = (r.recurrente || r.total) + ejemplo.compPrecio;
      var yaGratis = (r.recurrente || r.total) >= ENVIO_MIN;
      modal.querySelector('[data-ap-up-texto]').textContent = llenar(yaGratis ? T.upsellTextFree : T.upsellText, {
        precio: dinero(ejemplo.compPrecio),
        total: dinero(totalCon)
      });

      candidatos.forEach(function (id) {
        var p = productos[id];
        var card = document.createElement('div');
        card.className = 'ms-ap__up';
        if (p.foto) {
          var img = document.createElement('img');
          img.src = p.foto;
          img.alt = '';
          card.appendChild(img);
        }
        var nom = document.createElement('span');
        nom.className = 'ms-ap__up-name';
        nom.textContent = p.nombre;
        card.appendChild(nom);
        var pr = document.createElement('span');
        pr.className = 'ms-ap__up-price';
        pr.textContent = dinero(p.compPrecio);
        if (p.compAntes > p.compPrecio) {
          var s = document.createElement('s');
          s.textContent = dinero(p.compAntes);
          pr.appendChild(s);
        }
        card.appendChild(pr);
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = T.upsellAdd;
        b.addEventListener('click', function () {
          if (estado.extras.length < MAX_EXTRAS) estado.extras.push(id);
          cerrarUpsell();
          pintar();
        });
        card.appendChild(b);
        lista.appendChild(card);
      });

      mostrarModal(lista);
    }

    function cerrarUpsell() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    if (modalOtro) modalOtro.addEventListener('click', function () { abrirUpsell('50'); });

    modal.querySelectorAll('[data-ap-cerrar]').forEach(function (el) {
      el.addEventListener('click', cerrarUpsell);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) cerrarUpsell();
    });

    /* Aviso corto abajo: confirma qué se agregó, para el que no vio el panel. */
    var aviso = null, avisoT = null;
    function avisar(texto) {
      if (!texto) return;
      if (!aviso) {
        aviso = document.createElement('div');
        aviso.className = 'ms-ap__aviso';
        aviso.setAttribute('role', 'status');
        document.body.appendChild(aviso);
      }
      aviso.textContent = texto;
      aviso.classList.add('is-on');
      clearTimeout(avisoT);
      avisoT = setTimeout(function () { aviso.classList.remove('is-on'); }, 2600);
    }

    /* ── acciones ── */
    function agregarFrasco(id) {
      if (repetidoEnSub(id)) return;
      if (tocaExtra(productos[id])) {
        estado.extras.push(id);
        estado.upsellVisto[estado.modo] = true;
        pintar();
        return;
      }
      if (estado.frascos.length >= limite()) return;
      if (!disponible(productos[id], estado.modo)) return;
      estado.frascos.push(id);
      if (estado.modo === 'sub') estado.frascos.push(id); /* su 2x1 completo */
      recienLlena = estado.frascos.length - 1;
      pintar();
      if (estado.modo === 'sub') avisar(llenar(T.avisoPar, { producto: productos[id].nombre, precio: corto(precioSub(productos[id]) * 2) }));
      tocaUpsell();
    }

    /* El upsell sale UNA vez, justo al completar los 2 de la suscripción. */
    function tocaUpsell() {
      if (estado.extras.length || estado.upsellVisto[estado.modo]) return;
      var justo = estado.modo === 'sub'
        ? estado.frascos.length === SUB_FRASCOS
        : estado.frascos.length === MIN_ONCE;
      if (justo) setTimeout(function () { abrirUpsell(estado.modo === 'sub' ? '2x1' : '50'); }, 350);
    }

    /* Las dos mitades del pack van con la misma cantidad, variante y plan, y
       con la frase para bodega: exactamente como las agrega su página. */
    function lineasPack(pk) {
      var op = opcionPack(pk);
      if (!op) return [];
      var props = { 'Este pedido lleva': op.armado, Oferta: op.nombre };
      return [op.idPr, op.idAc].map(function (id) {
        var l = { id: Number(id), quantity: op.packs, properties: props };
        if (op.plan) l.selling_plan = Number(op.plan);
        return l;
      });
    }

    packs.forEach(function (pk) {
      var boton = pk.el.querySelector('[data-ap-pack-cta]');
      boton.addEventListener('click', function () {
        var pedidas = lineasPack(pk);
        if (!pedidas.length) return;
        enviar(pedidas, [boton], pk.el.querySelector('[data-ap-pack-error]'));
      });
    });

    function quitarFrasco(id) {
      var i = estado.frascos.lastIndexOf(id);
      var k = estado.extras.lastIndexOf(id);
      if (k !== -1) {
        estado.extras.splice(k, 1);
        pintar();
        return;
      }
      if (i === -1) return;
      if (estado.modo === 'sub') estado.frascos.splice(i - (i % 2), 2);
      else estado.frascos.splice(i, 1);
      pintar();
    }

    orden.forEach(function (id) {
      var el = productos[id].el;
      var agregar = el.querySelector('[data-ap-agregar]');
      el.dataset.textoAgregar = agregar.textContent;
      agregar.addEventListener('click', function () { agregarFrasco(id); });
      el.querySelector('[data-ap-mas]').addEventListener('click', function () { agregarFrasco(id); });
      el.querySelector('[data-ap-menos]').addEventListener('click', function () { quitarFrasco(id); });
    });

    raiz.querySelectorAll('[data-ap-modo]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (estado.modo === b.dataset.apModo) return;
        estado.modo = b.dataset.apModo;
        pintar();
        tocaUpsell();
      });
    });

    /* «Cambiar a suscripción» desde la comparativa: se quedan los primeros 2
       frascos que eligió (el 2x1 va de dos en dos). */
    var vsCta = raiz.querySelector('[data-ap-vs-cta]');
    if (vsCta) {
      vsCta.addEventListener('click', function () {
        estado.modo = 'sub';
        pintar();
        tocaUpsell();
        var panel = raiz.querySelector('.ms-ap__panel');
        if (panel && panel.getBoundingClientRect().top < 0) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ── al carrito ── */
    function lineas() {
      var ls = [];
      var cuenta = {};

      function sumar(clave, linea) {
        if (cuenta[clave]) { cuenta[clave].quantity += 1; return; }
        cuenta[clave] = linea;
        ls.push(linea);
      }

      if (estado.modo === 'once') {
        var pagados = [];
        var gratis = [];
        estado.frascos.forEach(function (id, i) { (i % 3 === 2 ? gratis : pagados).push(id); });
        /* Primero los pagados y luego los gratis: así el guardián ya ve con
           qué se gana cada regalo cuando llega. */
        pagados.forEach(function (id) {
          var p = productos[id];
          sumar('o' + id, { id: Number(p.onceId), quantity: 1, properties: { Oferta: raiz.dataset.ofertaOnce } });
        });
        gratis.forEach(function (id) {
          var p = productos[id];
          sumar('r' + id, { id: Number(p.regaloId), quantity: 1, properties: { Oferta: raiz.dataset.ofertaOnce } });
        });
        extrasAlCarrito(ls);
      } else {
        estado.frascos.forEach(function (id) {
          var p = productos[id];
          sumar('s' + id, { id: Number(planDe(p).vid || p.subId), quantity: 1, selling_plan: Number(planDe(p).id), properties: { Oferta: llenar(raiz.dataset.ofertaSub, { cada: cadaTexto() }) } });
        });
        extrasAlCarrito(ls);
      }
      return ls;
    }

    /* Cada frasco extra va en SU PROPIA línea de cantidad 1, aunque sean dos
       del mismo producto: la propiedad oculta `_extra` las separa. Así el
       guardián del carrito sigue aplicando su regla de «1 por línea» a los
       complementos (la que impide subir a mano la cantidad de un complemento
       al 50%) sin tener que tocarla. */
    function extrasAlCarrito(ls) {
      estado.extras.forEach(function (id, k) {
        var e = productos[id];
        ls.push({ id: Number(e.compId), quantity: 1, properties: { _complemento: '1', _extra: String(k + 1), Oferta: raiz.dataset.ofertaComp } });
      });
    }

    function planSobrevivio(pedidas, cuerpo) {
      var devueltos = (cuerpo && cuerpo.items) || [];
      return pedidas.every(function (l) {
        if (!l.selling_plan) return true;
        return devueltos.some(function (it) {
          return it.variant_id === l.id && it.selling_plan_allocation &&
                 it.selling_plan_allocation.selling_plan &&
                 it.selling_plan_allocation.selling_plan.id === l.selling_plan;
        });
      });
    }

    function deshacer(pedidas, cuerpo) {
      var updates = {};
      ((cuerpo && cuerpo.items) || []).forEach(function (it) {
        if (pedidas.some(function (l) { return l.id === it.variant_id; })) updates[it.key] = 0;
      });
      return fetchLimpio()('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }

    function alCarrito() {
      var r = calcular();
      if (!r.listo) return;
      enviar(lineas(), [].slice.call(raiz.querySelectorAll('[data-ap-cta]')), raiz.querySelector('[data-ap-error]'));
    }

    /* Un solo camino al carrito para el constructor y para el pack. */
    function enviar(pedidas, botones, error) {
      error.hidden = true;
      botones.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); b.textContent = T.ctaLoading; });

      var secciones = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        if (secciones.indexOf(el.dataset.sectionId) === -1) secciones.push(el.dataset.sectionId);
      });
      var cuerpo = JSON.stringify({
        items: pedidas,
        sections: secciones.length ? secciones.join(',') : undefined,
        sections_url: window.location.pathname
      });
      var url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      porXHR(url, cuerpo)
        .then(function (res) {
          if (!res.ok || planSobrevivio(pedidas, res.cuerpo)) return res;
          /* Alguien borró el plan en el camino: se deshace y se repite por el
             fetch limpio para que la suscripción nunca quede a precio de
             compra única. */
          return deshacer(pedidas, res.cuerpo).then(function () {
            return fetchLimpio()(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: cuerpo
            }).then(function (r2) { return r2.json().then(function (d) { return { ok: r2.ok, cuerpo: d }; }); });
          });
        })
        .then(function (res) {
          botones.forEach(function (b) { b.removeAttribute('aria-busy'); });

          if (!res.ok) {
            error.hidden = false;
            error.textContent = (res.cuerpo && (res.cuerpo.description || res.cuerpo.message)) || T.error;
            pintar();
            return;
          }

          var evento = new Event('cart:update', { bubbles: true });
          evento.detail = {
            resource: res.cuerpo,
            sourceId: 'ms-arma-paquete',
            data: {
              source: 'ms-arma-paquete',
              itemCount: res.cuerpo && res.cuerpo.item_count,
              variantId: String(pedidas[0].id),
              sections: res.cuerpo && res.cuerpo.sections
            }
          };
          document.dispatchEvent(evento);

          botones.forEach(function (b) { b.classList.add('is-done'); b.textContent = T.ctaDone; });
          setTimeout(function () {
            botones.forEach(function (b) { b.classList.remove('is-done'); });
            pintar();
          }, 2500);

          var cajon = document.querySelector('cart-drawer-component');
          if (cajon && typeof cajon.open === 'function') {
            cajon.open();
          } else {
            window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          botones.forEach(function (b) { b.removeAttribute('aria-busy'); });
          error.hidden = false;
          error.textContent = T.error;
          pintar();
        });
    }

    raiz.querySelectorAll('[data-ap-cta]').forEach(function (b) {
      b.addEventListener('click', alCarrito);
    });

    /* Filtro del muro de reseñas por producto. */
    var chips = raiz.querySelector('[data-ap-chips]');
    if (chips) {
      chips.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-ap-chip]');
        if (!chip) return;
        var clave = chip.dataset.apChip;
        chips.querySelectorAll('[data-ap-chip]').forEach(function (c) {
          c.classList.toggle('is-on', c === chip);
          c.setAttribute('aria-selected', c === chip ? 'true' : 'false');
        });
        raiz.querySelectorAll('[data-ap-rev]').forEach(function (card) {
          card.hidden = !!clave && card.dataset.apRev !== clave;
        });
        var muro = raiz.querySelector('[data-ap-wall]');
        if (muro) muro.scrollLeft = 0;
      });
    }

    pintar();
  }

  function todos() {
    document.querySelectorAll('[data-ms-ap]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todos);
  } else {
    todos();
  }
  document.addEventListener('shopify:section:load', todos);
})();
